import React from 'react';
import callToActionIcon from '../../../../../../assets/icons/icon-whatsap.svg';
import { Button, Containe } from './styles';

interface ButtonWhatsappProps {
  tabIndex?: number;
}

const ButtonWhatsapp: React.FC<ButtonWhatsappProps> = ({ tabIndex = 0 }) => {
  const handleClick = () => {
    window.open(
      'https://api.whatsapp.com/send?phone=51960252970&text=Hola, tengo una consulta',
      '_blank',
      'noopener,noreferrer'
    );
  };
  return (
    <Button type="submit" onClick={handleClick} tabIndex={tabIndex}>
      <img src={callToActionIcon} alt="" />
      <p>Escríbenos en Whatsapp</p>
    </Button>
  );
};

const CallToAction = ({ tabIndex = 30 }: ButtonWhatsappProps) => (
  <Containe>
    <p>
      Puedes llamarnos a: <span>0801 19600 ó 315 9600</span>
    </p>
    <ButtonWhatsapp tabIndex={tabIndex} />
  </Containe>
);
export default CallToAction;
